import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MapSupervisionHelper } from '@solar/ol';
import { IssueTypeHelper } from '@solar/solar/models';
import { SupervisionError, Supervision, Site } from 'solar-bo';
import { IIssueEditOptions } from '../../issue-edit/iissueeditoptions.interfaces';
import { IssuecanvasComponent } from '../../issuecanvas/issuecanvas.component';
import { IssueImageComponent } from '../../issueimage/issueimage.component';


@Component({
  selector: 'app-issueview',
  templateUrl: './issueview.component.html',
  styleUrls: ['./issueview.component.scss']
})
export class IssueViewComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() site:Site;
  @Input() issue:SupervisionError;
  @Input() issueList:SupervisionError[];
  @Input() showIssueOnCanvas:boolean=false;
  @Input() imageurl;
  @Input() options:IIssueEditOptions={showIssueOnCanvas:false, openimage:true};
  @Input() toolbarOptions={showFilters:true};


  @ViewChild('issue_canvas') issue_canvas: IssuecanvasComponent;
  supervision:Supervision;
  showtemp:boolean=true;
  issuetitle:string="Issue";
  canvas_options = { zoom:1 };
  canvasWidth=320;
  canvasHeight=256;

  /**
   * generic event raise
   */
  @Output() onActionClick=new EventEmitter();

  
  constructor(public dialog: MatDialog) { }

  ngOnInit() {
    if (this.issue){
      //this.issue.supervision=this.supervision;
      this.site=this.issue.supervision.site;
      this.supervision=this.issue.supervision;
      this.imageurl=MapSupervisionHelper.issueUrlImg(this.issue, this.site.id, this.supervision.id);
      let panel_pattern=Site.getPanelPattern(this.issue.supervision.site, "list");
      
      this.issuetitle=SupervisionError.uiLocatorByPanel(this.issue.info.panel,panel_pattern);

    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("IssuecanvasComponent ngOnChanges " ,changes);
    let typeChange = changes['issue'];
    if (typeChange && !typeChange.firstChange) {
    }
  }

  ngAfterViewInit(){

  }

  public static openModal(dialog: MatDialog, issue:SupervisionError,supervision:Supervision, options:any): MatDialogRef<IssueViewComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "900px";
    //dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<IssueViewComponent>;
    dialogRef = dialog.open(IssueViewComponent, dialogConfig);
    dialogRef.componentInstance.supervision = supervision;
    dialogRef.componentInstance.issue =issue;
    dialogRef.componentInstance.options =options;    

    return dialogRef;
  }

  /**
   * Show the description of an issue 
   * @param issue 
   */
  ui_errortype(issue) {
    return IssueTypeHelper.issueGetErrorTypeDescription(issue.type);
  }

  ui_relevance(issue) {
    if (!issue) {
      return "";
    }

    if (issue.info){
      return issue.info.relevance;
    }
  }

  uiurlimg(issue: SupervisionError): string {
    return MapSupervisionHelper.issueUrlImg(issue, this.site.id, issue.supervision.id);
  }

  openimage() {
    if (!this.options.openimage){
      return;
    }
    IssueImageComponent.openModal(this.dialog, this.issue, this.issue.supervision);
  }
  canvas_onRightClick($event){
    this.onActionClick.emit({type:"CANVAS_RIGHT_CLICK",event:$event});
    
  }
  addIssueFromImage($event){
    this.onActionClick.emit({type:"ADD_ISSUE_FROM_IMAGE",event:$event});
  }

  filtergrayscale($event){
    this.issue_canvas.canvasFilter.filtergrayscale($event);
  }

  filterInvert($event){
    this.issue_canvas.canvasFilter.filterInvert($event);
  }


  
}
